import React, { ReactNode, CSSProperties } from "react"
import * as styles from "./Content.module.css"
import useDeviceType from "../../../../hooks/useDeviceType"
import classNames from "classnames"

type SectionProps = {
  columns?: number
  rows?: number
  gap?: number
  topSpace?: number | string
  topSpaceResponsive?: number | string
  width?: number | string
  height?: number | string
  reverseResponsive?: boolean
  centerResponsive?: boolean
  autoSize?: boolean
  children: ReactNode
  style?: CSSProperties
  id?: string
}

const Content = ({
  columns = 1,
  rows = 1,
  gap = 16,
  topSpace = 0,
  topSpaceResponsive = 70,
  width,
  height,
  reverseResponsive = false,
  centerResponsive = false,
  autoSize = false,
  children,
  style = {},
  id,
}: SectionProps) => {
  //

  const DeviceType = useDeviceType()

  // Columns
  const calculateColumns = (columns: number) => {
    if (DeviceType === "tablet" || DeviceType === "mobile") {
      if (columns === 2) return 1
      if (columns === 4) return 2
      if (columns === 5 || columns === 6) return 3
    } else return columns
  }

  // Top Space
  const calculateTopSpace = (
    topSpace: number | string,
    topSpaceResponsive: number | string
  ) => {
    if (topSpace && (DeviceType === "tablet" || DeviceType === "mobile")) {
      return typeof topSpaceResponsive === "number"
        ? `${topSpaceResponsive}px`
        : topSpaceResponsive
    } else return typeof topSpace === "number" ? `${topSpace}px` : topSpace
  }

  // Gap
  const calculateGap = (gap: number) => {
    if (DeviceType === "tablet" || DeviceType === "mobile") {
      return "40px"
    } else return `${gap}px`
  }

  // All Styles
  const gridStyle: CSSProperties = {
    gridTemplateColumns: `repeat(${calculateColumns(columns)}, ${
      autoSize ? "auto" : "1fr"
    })`,
    gridTemplateRows: `repeat(${rows}, ${autoSize ? "auto" : "1fr"})`,
    gap: calculateGap(gap),
    marginTop: calculateTopSpace(topSpace, topSpaceResponsive),
    ...(typeof width === "number" ? { width: `${width}px` } : { width: width }),
    ...(typeof height === "number" ? { height: `${height}px` } : { height }),
    ...style,
  }

  return (
    <div
      className={classNames(styles.container, {
        [styles.reverseResponsive]: reverseResponsive,
        [styles.centerResponsive]: centerResponsive,
      })}
      style={gridStyle}
      id={id}
    >
      {children}
    </div>
  )
}

export default Content
